import { ErrorMessage } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { error } from '../model'

Error.displayName = 'Error'
export function Error(): JSX.Element | null {
  const { t } = useTranslation()

  const { err1, err2 } = useUnit({
    err1: error.$loading,
    err2: error.$accept,
  })

  if (err1) return <ErrorMessage width='100%' title={t(err1)} />
  if (err2) return <ErrorMessage width='100%' title={t(err2)} />
  return null
}
